import React, { Component } from "react";
import Header from "../layout/headerHome";
import Footer from "../layout/footerUpdated";
import { Helmet } from "react-helmet";

class privacyPolicies extends Component {
  render() {
    return (
      <>
        <Header />
        <Helmet>
          <title>Privacy Policy</title>
          <meta
            name="description"
            content="Vaccination for Shingles at  Bridge Health Medical and Digital Solution Private Limited: Herpes Zoster, caused by the varicella-zoster virus. Discover symptoms, Vaccines, treatments, & solutions for effective management."
          />
        </Helmet>
        <section>
          <section className="term-policy auto-container image-mobile-terms">
            <div className="terms-heading">
              <h2 className="heading1-policy">Privacy Policy</h2>
              <div className="text-align-center d-flex justify-content-center">
                {/* <button
                  className="submitcontact disply-on-mobile "
                  type="submit"
                  name="submit-form"
                >
                  Share
                </button> */}
              </div>
              <p>
                This Privacy Policy describes Our policies and procedures on the
                collection, use and disclosure of Your information when You use
                the Service and tells You about Your privacy rights and how the
                law protects You. We use Your Personal data to provide and
                improve the Service. By using the Service, You agree to the
                collection and use of information in accordance with this
                Privacy Policy.
              </p>
            </div>
            <div>
              <h4 style={{ fontSize: '24px', fontWeight: 'bold', marginTop: '10px'}}>Preface</h4>
              <p>
              Bridge Health Medical and Digital Solution Private Limited, a company incorporated under the laws of India, having its registered office at, No.166-167, 21st Main Road, 100 Feet Ring Road, 2nd Phase, JP Nagar, Bangalore - 560078 (hereinafter referred to as 
                <strong>"Bridge Health/we/our" </strong> ) has devised, adopted, implemented and is operating the app and website (including but not limited to software applications and mobile applications, hereinafter referred to as <strong>"Digital Platform"</strong>) for providing a catena of Services.
              </p>
            </div>
            <div>
            <h4 style={{ fontSize: '24px', fontWeight: 'bold', marginTop: '10px'}}>Privacy Policy</h4>

              <p>
                This Privacy Policy (<strong>"Policy"</strong>) is made, and
                hosted in accordance with the following Information Technology
                Laws,
                <div>
                  <ul>
                  <li style={{ fontSize: '18px'}}>
                  a. Information Technology Act, 2000 and its associated Rules; and
                  </li>
                  <li style={{ fontSize: '18px'}}>
                  b. The Digital Personal Data Protection Act, 2023 and its Rules. 
                  </li>
                  </ul>
                </div>
              </p>
            </div>

            <div>
            <h4 style={{ fontSize: '24px', fontWeight: 'bold', marginTop: '10px'}}>Purpose of the Policy</h4>
              <p>
              This Privacy Policy describes our policies and procedures on the collection, use and disclosure of your Personal Information/Data (<strong>"Information"</strong>) when You use Services provided on our Digital Platform. By using our Services, You agree and consent to the collection and processing of your data in accordance with this Privacy Policy.
              </p>

              <h4 style={{ fontSize: '24px', fontWeight: 'bold', marginTop: '10px'}}>General Terms</h4>
              <ul>
              <li style={{ fontSize: '18px'}}>
              1.	This Policy is to be read in conjunction with and shall be deemed to be part of the Digital Platform’s Terms of Use.<br/>
              </li>
              <li style={{ fontSize: '18px'}}>
2.	The User(s) hereby agree, consent and acknowledge that the Information shared by them, collected or collated through the Digital Platform could be stored, processed and handled by Bridge Health or through its trusted third-party service providers as set out in this Privacy Policy.<br/>
</li>
<li style={{ fontSize: '18px'}}>
3.	For the purpose of this Policy, User(s) shall mean such individuals who are competent to contract under the Indian Contract Act, 1872 and wish to subscribe to the Services on this Digital Platform. <br/>
</li>
<li style={{ fontSize: '18px'}}>
4.	We therefore request the User(s) on this Digital Platform, to carefully and comprehensively read and understand the Policy before consenting to the same. In the event of any disagreement or in the case that User(s) do not accept the terms of this Policy or the Terms of Use of this Digital Platform they are advised to forthwith disengage and leave the Digital Platform.<br/>
</li>
<li style={{ fontSize: '18px'}}>
5.	Bridge Health may provide certain of the Services contemplated under this Digital Platform directly by itself or through third party service providers. This Digital Platform may contain links of such third-party service providers and their Digital Platform. Bridge Health shall not in any way be responsible for the content, Terms of Use, Privacy Policy, the mode of operations of such third-party service providers.<br/>
</li>
<li style={{ fontSize: '18px'}}>
6.	If a User(s) unsubscribes from the Services and again intends to avail/subscribe to the Services, he/she is authorizing Bridge Health to send such information as may be required, including but not limited to SMS/emails for enabling the User(s) to continue to avail the Services. User(s) hereby explicitly consent and agree that any request pursuant to this clause will override any opt-out/ override any opt-out unsubscribe request given by them earlier.<br/>
</li>
<li style={{ fontSize: '18px'}}>
7.	By agreeing to the terms of this Policy, User(s) consent to avail consultation via telemedicine. Such consent is implied as and when the User(s) initiates such consultation via the Digital Platform.<br/>
</li>
<li style={{ fontSize: '18px'}}>
8.	After User(s) create the account and if there is any change in the Information provided earlier, the User(s) can edit their profile and make necessary modifications. User(s) are solely responsible for the Information provided by them.<br/>
</li>
</ul>
  <h4 style={{ fontSize: '24px', fontWeight: 'bold', marginTop: '10px'}}>User Information and Processing</h4>

              <p>
              We collect and process the following categories of user Information:
              </p>

              <div>
                <p>
              <ul>
                <li style={{ fontSize: '18px'}}>
                1.	<strong>Identity Details</strong>- name, age/DoB, gender, address etc.;
                </li> 
                <li style={{ fontSize: '18px'}}>
2.	<strong>Contact Details</strong>- phone number, email address etc.;
</li>
<li style={{ fontSize: '18px'}}>
3.	<strong>Personal Health Information (PHI)</strong>- medical history, diagnostic data, prescriptions etc.;
</li>
<li style={{ fontSize: '18px'}}>
4.	<strong>Sensitive Personal Data</strong>-biometric data, PAN, Aadhaar details (if required);
</li>
<li style={{ fontSize: '18px'}}>
5.	<strong>Technical Information</strong>- IP address, browser details, device identifiers etc.; 
</li>
<li style={{ fontSize: '18px'}}>
6.	<strong>Security Details</strong>- login credentials, passwords (encrypted) etc.;
</li>
<li style={{ fontSize: '18px'}}>
7.	<strong>Other Details</strong>- Data from health apps (Google Fit, Apple Health) and other fitness and medical devices as may be required for providing the Services.
</li>
</ul>
                </p>
              </div>

              <p>
              We do not share any Identifiable Personal Information with any individuals, organizations and other companies, except our third-party business partners, under strict confidentiality. User(s) Information is securely stored and utmost confidentiality is maintained and may be accessed/used/disseminated by us as per the terms specified herein.
<br/>Bridge Health may keep records of electronic communications and telephone calls received and made for making appointments or other purposes for the purpose of administration of Services, customer support, research and development.
<br/>Users may choose not to provide certain personal data. However, this may limit the availability of certain services.

              </p>

              <h4 style={{ fontSize: '24px', fontWeight: 'bold', marginTop: '10px'}}> Purpose for Information Collection</h4>
              <p>
              We collect and process Information for the following purposes and the User(s) explicitly consent to the same:
              </p>
              <ul>
                <li style={{ fontSize: '18px'}}>
              1.	Communicating with the User(s); 
              </li>
              <li style={{ fontSize: '18px'}}>
2.	Providing the Services contemplated under this Digital Platform;
</li>
<li style={{ fontSize: '18px'}}>
3.	Offering new Services;
</li>
<li style={{ fontSize: '18px'}}>
4.	Analytical purposes in anonymous form or as de-identified data and for this purpose we may take assistance of our affiliates and trusted business partners in India or outside India for research, development, studies, betterment of services, understanding the User(s) Experience, serving the individual needs of the User(s) and improving the overall health delivery services/health outcome of the User(s). Bridge Health may disclose aggregated information, but it will never contain Information that will identify a single User(s).
</li>
<li style={{ fontSize: '18px'}}>
5.	Obtaining feedback;
</li>
<li style={{ fontSize: '18px'}}>
6.	For conducting Audit(s)/Review;
</li>
<li style={{ fontSize: '18px'}}>
7.	Customizing User(s) needs and send personalized communications. 
</li>
<li style={{ fontSize: '18px'}}>
8.	Link User(s) Account with third party(ies) health account(s) including but not limited to Google Fit/ Apple Health for tracking their health activities and health vitals and such other third party(s) as may be required for providing the Services available on the Digital Platform.
</li>
<li style={{ fontSize: '18px'}}>
9.	To send communications including but not limited to emails, SMS etc. intimating the User(s) about Bridge Health's healthcare services, healthcare packages, offers and other promotional content as well as for reminders and notifications as logged on the app by the User(s) or their healthcare provider. These messages may be sent using various third-party service providers.
</li>
<li style={{ fontSize: '18px'}}>
10.	Fraud Prevention & Security: Ensuring platform integrity and preventing misuse.
</li>
              </ul>

              <h4 style={{ fontSize: '24px', fontWeight: 'bold', marginTop: '10px'}}>Disclosure and Sharing of Information</h4>
              <p>
              We do not sell or trade personal data. However, we may share data with:
              </p>
              <ul>
                <li style={{ fontSize: '18px'}}>
              1.	  <strong>Healthcare Providers & Laboratories:</strong> To facilitate medical consultations, tests, and reports.
</li>
<li style={{ fontSize: '18px'}}>
2.	<strong>Third-Party Service Providers:</strong> Logistics, payment processors, and IT service providers, among others. They are all bound by strict confidentiality and data protection agreements.
</li>
<li style={{ fontSize: '18px'}}>
3.	<strong>Audit/review purposes:</strong> Information may be used by Bridge Health or shared with Third Party(ies) for the purpose of (1) review/conducting Audits, with the intent of improving the overall quality of services and care, training of Healthcare Professionals, for providing enhanced consultation experience to User(s), (2) handling complaints, and (3) meeting the regulatory or statutory requirements. Bridge Health assures that any information exchanged for the said purposes shall be subject to stringent confidentiality obligations imposed on such Third Party(ies).
</li>
<li style={{ fontSize: '18px'}}>
4.	<strong>Analytics purposes:</strong> For improving the Services and user experience.
</li>
<li style={{ fontSize: '18px'}}>
5.	<strong>Regulatory Authorities:</strong> If required by law or directed by a court order.
</li>
<li style={{ fontSize: '18px'}}>
6.	<strong>Cross-Border Data Transfers:</strong> If data is stored or processed outside India, we ensure compliance with data localization and cross-border transfer provisions of DPDPA, 2023 or any other law for the time being in force.
</li>
              </ul>

              <h4 style={{ fontSize: '24px', fontWeight: 'bold', marginTop: '10px'}}>Data Retention & Deletion</h4>

              <div>
                <p>
                <ul>
                  <li style={{ fontSize: '18px'}}>
                  1. We retain user data only for the duration required by applicable laws or until the purpose for which it was collected is fulfilled.
                  </li>
                  <li style={{ fontSize: '18px'}}>
                  2. Users can request deletion of their personal data by contacting us at info@bridgehealthgroup.com/ legal@bridgehealthgroup.com. 
                  </li>
                  <li style={{ fontSize: '18px'}}>
                  3. Upon withdrawal of consent, data will be securely erased/retained for a particular duration, in line with the applicable laws.
                  </li>
                </ul>
                </p>
              </div>

              <div>
              <h4 style={{ fontSize: '24px', fontWeight: 'bold', marginTop: '10px'}}>Modification of Policy </h4>
                <p>
                Notwithstanding anything contained herein or the Terms of Use, Bridge Health reserves its right to add, update, change, edit, alter, amend, modify, review, revise, vary or substitute this Policy with or without prior notice to the User(s) once an initial agreement and consent is taken after a complete understanding of the Policy, first displayed.
<br/>By using or accessing this Digital Platform, the User(s) categorically agrees to have read and understood this Policy and acknowledge that they shall be bound by the terms of this Policy including any addition, updation, change, amendment, revision, modification and/or substitution. Bridge Health reserves its right to terminate the services of any User(s) who do not subscribe to or violate the terms of this Policy.
                </p>
              </div>

              <div>
              <h4 style={{ fontSize: '24px', fontWeight: 'bold', marginTop: '10px'}}>Cookie Policy</h4>
                <p>
                Cookies are small pieces of text used to store information on web browsers. Cookies are used to store and receive identifiers and other information on computers, phones and other devices. Other technologies, including data we store on User(s) web browser or device, identifiers associated with User(s) device, and other software, are used for similar purposes.
<br/>The Digital Platform uses cookies to store certain data (that is not sensitive personal data or information) that is used to provide customized information when the User(s) or Unregistered User(s) return to the Website. "Cookies" are used to store User(s) or Unregistered User(s) preferences and to track User(s) or Unregistered User(s) trends, so as to enhance their interactive experience and generally improve the website's services to them. While serving advertisements or optimizing services to its User(s), Bridge Health may allow authorized third parties, for analytical and statistical purposes, to place or recognize a unique cookie on the User(s) or Unregistered User(s) browser.
                </p>
              </div>

              <div>
              <h4 style={{ fontSize: '24px', fontWeight: 'bold', marginTop: '10px'}}>Security and Restrictions</h4>
                <p>
                <ul>
                <li style={{ fontSize: '18px'}}>
                1.	We implement industry-standard encryption, access controls, and secure storage mechanisms to protect user data. However, while we take reasonable precautions, no system is 100% secure, and users should also ensure their credentials remain confidential.
</li>
<li style={{ fontSize: '18px'}}>
2.	Bridge Health makes all User information accessible to its employees, agents or partners and third parties only on a need-to-know basis. All Bridge Health employees and data processors, who have access to, and are associated with the processing of Information, are obliged to respect the confidentiality of every End-Users’ Personal Information or Sensitive Personal Data and Information. However, Bridge Health shall be  liable only for the actions/breaches of its employees and not of any third -party.
</li>
<li style={{ fontSize: '18px'}}>
3.	Notwithstanding anything contained in this Policy or elsewhere, Bridge Health shall not be held responsible for any loss, damage or misuse of the User(s) Information, if such loss, damage or misuse is attributable to a Force Majeure Event. A "<strong>Force Majeure Event</strong>" means any event that is beyond the reasonable control of Bridge Health and includes, without limitation, fire, flood, explosion, acts of God, civil commotion, strikes, lock outs or industrial action of any kind, riots, insurrection, war, acts of government, power failure, sabotage, computer hacking, unauthorised access to computer data and storage device, system failure, virus, attacks, bugs, computer crashes, breach of security and encryption.
</li>
<li style={{ fontSize: '18px'}}>
4.	Your Information is maintained by Bridge Health in electronic form on its equipment, and on the equipment of its employees. Such information may also be converted to physical form from time to time. Bridge Health takes all necessary precautions to protect your personal information both online and off-line, and implements reasonable security practices and measures including certain managerial, technical, operational and physical security control measures that are commensurate with respect to the information being collected and the nature of Bridge Health’s business.
</li>
<li style={{ fontSize: '18px'}}>
5.	Bridge Health does not undertake any liability for any unauthorized use of your account and password. If you suspect any unauthorized use of your account, you must immediately notify Bridge Health by sending an email to info@bridgehealthgroup.com/legal@bridgehealthgroup.com . You shall be liable to indemnify Bridge Health due to any loss suffered by it due to such unauthorized use of your account and password.
</li>
</ul>
              </p>
              </div>

              <div>
              <h4 style={{ fontSize: '24px', fontWeight: 'bold', marginTop: '10px'}}>
                Breach Notification Policy
                </h4>
                <p>
                In case of a data breach:
                </p>
                <ul>
                  <li style={{ fontSize: '18px'}}>
                  1.	Users will be notified within 72 hours of detection.
                  </li>
                  <li style={{ fontSize: '18px'}}>
                  2.	Relevant regulatory authorities will be informed as per CERT-In guidelines.
                  </li>
                  <li style={{ fontSize: '18px'}}>
                  3.	Remedial actions will be taken to mitigate risks.
                  </li>
                </ul>
              </div>

              <div>
              <h4 style={{ fontSize: '24px', fontWeight: 'bold', marginTop: '10px'}}>Withdrawal of consent </h4>
                <p>
                User(s) may if they so desire, withdraw their consent given to process the information and personal data collected by Bridge Health. The User(s) can reach out to Bridge Health by writing to them at  info@bridgehealthgroup.com/legal@bridgehealthgroup.com with a clear communication stating that they seek to withdraw such consent. In case of minors and persons incapable of giving consent, persons legally authorized to act on their behalf shall write to Bridge Health establishing they have authority to legally withdraw the consent so given. 
<br/>In furtherance of the same, Bridge Health will proceed to erase/destroy/retain for the prescribed period (as the case may be) the Information etc. collected on the Digital Platform from the User(s), in accordance with the Regulations/laws that it is bound by. 

                </p>
              </div>

              <div>
              <h4 style={{ fontSize: '24px', fontWeight: 'bold', marginTop: '10px'}}>Grievance and Complaints</h4>
                <p>
                In case of any complaints or grievances, the User(s) may contact Bridge Health at the below mentioned details:
                <br/>Address: No.166-167, 21st Main Road, 100 Feet Ring Road, 2nd Phase, JP Nagar, Bangalore – 560078.
                <br/>Email ID:  info@bridgehealthgroup.com/ legal@bridgehealthgroup.com.
                </p>
                <br/>
                <p>Once Bridge Health receives such grievances from User(s) it shall ensure to get back to them at the earliest and both Parties shall attempt to resolve the grievance, in a timely manner</p>
              </div>

              <div>
              <h4 style={{ fontSize: '24px', fontWeight: 'bold', marginTop: '10px'}}>Changes to This Privacy Policy</h4>
                <p>
                We may update this Privacy Policy from time to time. Significant changes will be communicated through email or in-app notifications. Continued use of our Services after updates constitutes acceptance of the revised policy.
                </p>
              </div>

              <div>
              <h4 style={{ fontSize: '24px', fontWeight: 'bold', marginTop: '10px'}}>Governing Law and Jurisdiction</h4>
                <p>
                The terms and conditions of this Policy shall be governed by Indian Laws and the courts at Bengaluru shall have exclusive jurisdiction to resolve any disputes.
                </p>
              </div>
            </div>
          </section>
        </section>
        <Footer />
      </>
    );
  }
}

export default privacyPolicies;
